<template>
  <v-card
    class="my-2 px-4 py-3 v-card-referral"
    :to="detailRoute"
    :color="colour"
    style="border-radius: 0.75rem"
    :flat="!referral.open"
    :class="{ closed: !referral.open }"
  >
    <v-container fluid class="ma-0 pa-0">
      <v-row no-gutters fill-height>
        <v-col cols="4" justify-content="space-between">
          <v-row
            no-gutters
            class="subtitle-1 text-uppercase mb-2"
            style="font-weight: 600;line-height: 1;letter-spacing:0.015em"
          >
            {{ referral.company_name }}
          </v-row>
          <v-row
            no-gutters
            class="body-2 mb-1 text-primary text-uppercase text--black"
            style="line-height: 1;letter-spacing:0.015em"
          >
            {{ referral.first_name }} {{ referral.last_name }}
          </v-row>
          <v-row no-gutters class="body-2 text-lowercase" style="line-height:1">
            {{ referral.email }}
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row no-gutters>
            <v-col cols="6" :class="{ 'text--secondary': !referral.open }">
              <div class="caption text--secondary text--darken-2" style="line-height: 1.1">Requested</div>
              <div class="subtitle-2" style="line-height: 1.1">{{ referral.requested_amount | currency }}</div>
            </v-col>
            <v-col cols="6" :class="{ 'text--secondary': !referral.open }">
              <div class="caption text--secondary text--darken-2" style="line-height: 1.1">Obtained</div>
              <div class="subtitle-2" style="line-height: 1.1">{{ referral.obtained_amount | currency }}</div>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="showReferrer" class="mt-1">
            <v-col>
              <div class="caption text--secondary text--darken-2" style="line-height: 1.1" v-if="referral.referrer">
                {{ referrerType }}
              </div>
              <div class="caption text--secondary text--darken-2" style="line-height: 1.1" v-else>Organic</div>
              <div v-if="referral.referrer" class="subtitle-2" style="line-height: 1.1">
                {{ referral.referrer.name }}
              </div>
              <div v-if="referral.referrer" style="line-height: 1.1">{{ referral.creator_name }}</div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row align-center justify-center fill-height>
            <enquiry-status-chip
              v-for="enquiry in referral.enquiries"
              :key="enquiry.id"
              :product="enquiry.product.name"
              :status="enquiry.status.name"
              :disabled="referral.closed"
              :revolving="enquiry.revolving"
            ></enquiry-status-chip>
          </v-row>
        </v-col>
        <v-col v-if="showOwner" justify="center" align="center">
          <v-row align-center justify-center fill-height no-gutters>
            <abf-owner-select :owners="OwnersList" :selected="referral.owner_id" @update:selected="updateOwner" />
          </v-row>
        </v-col>
        <v-col justify-content="space-between">
          <div class="caption text--secondary" style="text-align: right">
            {{ [referral.created_at, 'YYYY-MM-DD H:mm:ss'] | moment('calendar') }}
          </div>
          <v-row align="center" justify="end" no-gutters>
            <v-icon v-if="referral.email === null && !referral.customer.id" color="red">notifications_off</v-icon>
            <v-icon
              v-if="!UserHasRole('Broker')"
              class="pr-1"
              :color="referral.customer.auto_send_enquiries ? 'purple' : 'grey lighten-1'"
              >fad fa-shipping-fast</v-icon
            >
            <abf-question-completion-gauge
              v-if="referral.customer.id"
              :question_completion_percentage="referral.customer.question_completion_percentage"
            />
            <v-icon v-if="referral.customer.length < 1" color="red">fad fa-user-slash</v-icon>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AbfOwnerSelect from '@/components/Abf/AbfOwnerSelect';
import AbfQuestionCompletionGauge from '@/components/Abf/AbfQuestionCompletionGauge';
import EnquiryStatusChip from '../Widgets/EnquiryStatusChip';

export default {
  name: 'ReferralCard',
  components: { EnquiryStatusChip, AbfQuestionCompletionGauge, AbfOwnerSelect },
  props: {
    referral: Object,
    showReferrer: {
      type: Boolean,
      default: false
    },
    showOwner: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tabs: null
  }),
  computed: {
    ...mapGetters(['OwnersList', 'PlatformUser', 'UserHasRole', 'UILeftDrawer']),
    progressColour() {
      let colour = 'red';
      if (this.referral.question_completion_percentage === 100) {
        colour = 'accent';
      } else if (this.referral.question_completion_percentage >= 50) {
        colour = 'orange darken-2';
      }
      return colour;
    },
    colour() {
      return this.referral.closed ? 'grey lighten-3' : 'white';
    },
    detailRoute() {
      if (
        this.referral.customer.id &&
        (this.UserHasRole('Platform') || this.UserHasRole('Call Centre') || this.UserHasRole('Broker'))
      ) {
        return '/customers/' + this.referral.customer.id;
      } else {
        return '/referrals/' + this.referral.id;
      }
    },
    referrerType() {
      return this.referral.referrer.business_type === 'sub_partner' ? 'partner' : this.referral.referrer.business_type;
    }
  },
  methods: {
    ...mapActions(['getOwnersList', 'updateReferral']),
    updateOwner(ownerId) {
      this.updateReferral({
        id: this.referral.id,
        updates: { owner_id: ownerId, to_be_called: true }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card-referral {
  transition: flex 600ms cubic-bezier(0.19, 1, 0.22, 1);

  .inactive {
    opacity: 0.2;
  }
}
.caption {
  text-transform: capitalize;
}

.closed > div {
  opacity: 0.4;
}
</style>
